"use client";

import { useEffect } from "react";

import { registerPortalServiceWorker } from "@/lib/sw";

// Registers public/sw.js on every page, signed in or not: an installable web
// app needs a service worker, and it's what shows the offline page when the
// network is gone. Push subscriptions are separate and opt-in
// (components/push-toggle.tsx).
export function ServiceWorkerRegistrar() {
  useEffect(() => {
    if (!("serviceWorker" in navigator)) return;
    registerPortalServiceWorker().catch((err) => {
      console.warn("[sw] registration failed:", err);
    });
  }, []);
  return null;
}
